import * as React from 'react'
import { Tag } from 'antd'

interface IDemoTypeTag {
    isDemo?: boolean
    isDemoTemplate?: boolean
    /** Layout overrides only, for example the margin where a container already spaces its children. */
    style?: React.CSSProperties
}

// The list views render these tags inside a bold title, so they inherit the bold weight. Anywhere
// else the weight is set here, so the tag looks the same on every page.
const TAG_STYLE: React.CSSProperties = { marginLeft: 6, verticalAlign: 'middle', fontWeight: 700 }

/** Template wins over Demo when both flags are set; standard renders nothing. */
export const DemoTypeTag: React.FunctionComponent<IDemoTypeTag> = ({ isDemo, isDemoTemplate, style }) => {
    if (isDemoTemplate) {
        return (
            <Tag color="orange" style={{ ...TAG_STYLE, ...style }}>
                Template
            </Tag>
        )
    }

    if (isDemo) {
        return (
            <Tag color="blue" style={{ ...TAG_STYLE, ...style }}>
                Demo
            </Tag>
        )
    }

    return null
}

export default DemoTypeTag
